import { user_role } from "../../Config/Config";
import Api from "../../utils/axios";

export const UsersApi = {
  getAllCustomer: (payload, search = "") =>
    Api.post(
      `admin/get-all-users/${user_role.customer}?search=${search}`,
      payload
    ),
  getAllVendor: (payload, search = "") =>
    Api.post(
      `admin/get-all-users/${user_role.vendor}?search=${search}`,
      payload
    ),
  getAllDeliveryMan: (payload, search = "") =>
    Api.post(
      `admin/get-all-users/${user_role.deliveryman}?search=${search}`,
      payload
    ),
  getAllUsers: (payload, search = "") =>
    Api.post(`admin/get-all-users/${null}?search=${search}`, payload),

  getUserRole: () => Api.get("admin/get-all-user-roles"),
  generateOtp: (payload) => Api.post("auth/generate-otp", payload),
  verfiryOtp: (payload) => Api.post("auth/verify-otp", payload),
  resetPassword: (payload) => Api.post("auth/reset-password", payload),
  adminAllNotification: () => Api.get("admin/get-admin-notification"),
  markAdminNotificationRead: (notificationId) =>Api.put("admin/mark-notification-read", { notificationId }),
  markAllAdminNotificationsRead: () => Api.put("admin/mark-all-notification-read"), 
  approveUser: (id, payload) =>
    Api.patch(`admin/update-user-status/${id}`, payload),



  // Ticketing System
  getAllTickets: (payload, search = "") => Api.post(`user/get-all-tickets`, payload),
  replyToTicket: (id, payload) => Api.post(`user/reply-to-ticket/${id}`, payload),
  getTicketStats: () => Api.get(`user/ticket-stats`),
  getSingleTicket: (id) => Api.get(`user/ticket/${id}`),
  replyToTicket: (id, payload) =>Api.post(`user/reply-to-ticket/${id}`, payload),
  updateTicketStatus: (id, payload) =>Api.post(`user/update-ticket-status/${id}`, payload),
  deleteTicket: (id) =>Api.delete(`user/ticket/${id}`),


};
